import { observer } from 'src/utils/mobx-react';
import React from 'react';
import { LiabilitiesFilters } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters';
import { LiabilitiesFiltersProps } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.types';

export const LiabilitiesFiltersBox = observer(
    'LiabilitiesFiltersBox',
    ({ filters, competitions, onChange }: LiabilitiesFiltersProps) => (
        <LiabilitiesFilters
            competitions={competitions}
            onChange={onChange}
            filters={filters}
        />
    )
);
